const SmallBoxLink = () => {
    return (
        <div>small box link</div>
    )
}

export default SmallBoxLink;